import SelectField from '@/components/select-field'
import { Input } from '@/components/ui'
import FormGroup from '@/core/components/FormGroup'
import {
  REWARD_TYPE_KEYS,
  RewardConfigDto,
  RewardTypeKey,
  emptyRewardConfig,
} from '@/common/models/gamification'

interface RewardConfigFieldsProps {
  value: RewardConfigDto
  onChange: (next: RewardConfigDto) => void
}

/** Editor for a reward definition's config (polymorphic on `typeKey`). */
export const RewardConfigFields = ({
  value,
  onChange,
}: RewardConfigFieldsProps) => {
  const renderTypeFields = () => {
    switch (value.typeKey) {
      case 'COIN_VOUCHER':
        return (
          <FormGroup
            label="Coin voucher ID"
            error={
              value.coinVoucherId.trim() === ''
                ? 'Coin voucher ID is required'
                : undefined
            }
          >
            <Input
              isInvalid={value.coinVoucherId.trim() === ''}
              value={value.coinVoucherId}
              onChange={(e) =>
                onChange({ ...value, coinVoucherId: e.target.value })
              }
              type="text"
              placeholder="Enter coin voucher UUID"
            />
          </FormGroup>
        )
      case 'DISCOUNT_VOUCHER':
        return (
          <FormGroup
            label="Voucher ID"
            error={
              value.voucherId.trim() === ''
                ? 'Voucher ID is required'
                : undefined
            }
          >
            <Input
              isInvalid={value.voucherId.trim() === ''}
              value={value.voucherId}
              onChange={(e) =>
                onChange({ ...value, voucherId: e.target.value })
              }
              type="text"
              placeholder="Enter voucher UUID"
            />
          </FormGroup>
        )
      case 'TICKET':
        return (
          <FormGroup
            label="Ticket ID"
            error={
              value.ticketId.trim() === '' ? 'Ticket ID is required' : undefined
            }
          >
            <Input
              isInvalid={value.ticketId.trim() === ''}
              value={value.ticketId}
              onChange={(e) => onChange({ ...value, ticketId: e.target.value })}
              type="text"
              placeholder="Enter ticket UUID"
            />
          </FormGroup>
        )
      case 'HOTEL':
        return (
          <FormGroup
            label="Hotel ticket ID"
            error={
              value.ticketId.trim() === ''
                ? 'Hotel ticket ID is required'
                : undefined
            }
          >
            <Input
              isInvalid={value.ticketId.trim() === ''}
              value={value.ticketId}
              onChange={(e) => onChange({ ...value, ticketId: e.target.value })}
              type="text"
              placeholder="Enter hotel ticket UUID"
            />
          </FormGroup>
        )
      case 'PHYSICAL':
        return (
          <div className="text-xs text-monochrome-2">
            No extra configuration
          </div>
        )
    }
  }

  return (
    <div className="space-y-6 border-t border-monochrome-120 pt-6">
      <div className="text-lg font-bold text-monochrome-1">Reward config</div>

      <SelectField
        label="Reward type"
        required
        placeholder="Select reward type"
        value={value.typeKey}
        onValueChange={(v) => onChange(emptyRewardConfig(v as RewardTypeKey))}
        options={REWARD_TYPE_KEYS.map((k) => ({ value: k, label: k }))}
      />

      {renderTypeFields()}
    </div>
  )
}
